import { PropertyHelpers } from './PropertyHelpers';
import { FormControlProps } from '../interfaces/FormControlProps';
import { InputState } from '../formcontrols/Input';

export class FieldMaskHelpers{
    static testMaskedValue(component : React.Component<FormControlProps, InputState>, value : string){
        var regularExpression = new RegExp(
            PropertyHelpers.getMaskCharsExpression(component.props)
        );
        if (
          typeof component.props.formFieldDefinition
            .allowPrefixSpacesInInputOnly != "undefined" &&
          component.props.formFieldDefinition.allowPrefixSpacesInInputOnly ===
            true
        ) {
          value = value.replace(/^\s+/, "");
        }

        return {value, passTest : regularExpression.test(value)};

    }
}